import e from "../../utils/classNames.js";
import t from "../button/Button.js";
import { getTrackingLabelFromNode as n } from "../../utils/analytics/getTrackingLabelFromNode.js";
import { useDialogContext as r } from "./dialogContext.js";
import i from "react";
import { noop as a } from "es-toolkit/function";
import { jsx as o, jsxs as s } from "react/jsx-runtime";
//#region src/components/dialog/DialogHeader.tsx
var c = (c) => {
	let { title: l, subtitle: u, headerButtons: d, onCloseButtonClick: f = a, ...p } = c, { onClose: m, isSmallestDialog: h, showXsDialogBorders: g, showCloseButton: _ } = r(), v = !h || g, y = !h && _, b = e("modal-header", !v && "border-bottom-none"), x = e("modal-header-text", !v && "padding-bottom-0 width-100pct"), S = n(l), C = (e) => {
		f(), m(e);
	};
	return /* @__PURE__ */ s("div", {
		...p,
		className: b,
		"aria-label": "dialog header",
		children: [/* @__PURE__ */ s("div", {
			className: x,
			children: [u && /* @__PURE__ */ o("div", {
				className: "modal-header-subtitle",
				children: u
			}), /* @__PURE__ */ o("div", {
				className: "modal-header-title",
				children: l
			})]
		}), /* @__PURE__ */ s("div", {
			className: "modal-header-buttons",
			children: [d && !h && /* @__PURE__ */ s(i.Fragment, { children: [d, /* @__PURE__ */ o("div", { className: "modal-header-buttons-spacer" })] }), y && /* @__PURE__ */ o(t, {
				bsStyle: "muted",
				iconOnly: !0,
				iconName: "icon-remove",
				autoTrackingKey: S && `dialog::closed::${S}`,
				className: "modal-header-close close",
				onClick: C,
				"data-testid": "close",
				"aria-label": "dialog close button"
			})]
		})]
	});
};
//#endregion
export { c as default };

//# sourceMappingURL=DialogHeader.js.map